import { TranslatedEntity } from '../../../core/models/translated-entity';

export class PostLanguage extends TranslatedEntity<PostLanguage> {
  title = '';
  name = '';
  teaser = '';
  description = '';
}
